import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FeatureFlagsPage = lazy(() => import('~/features/platform/pages/feature-flags-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/feature-flags')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FeatureFlagsPage />
    </Suspense>
  ),
});
